import {WorkspaceTabKindType} from '@toolify/client/src/modules/workspaceTabs/enum/WorkspaceTabKindType'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'

export function getRouteWorkspaceTabKey(name: RouteName, params: Record<string, string>): string {
  const sorted = Object.keys(params).sort().map(key => `${key}=${params[key]}`).join('&')
  return `${WorkspaceTabKindType.Route}:${name}:${sorted}`
}
